import { contactServiceData } from "@services/info/contact";

class ContactService {
	async sendInquiry(contactModel: any) {
		return await contactServiceData.sendInquiry(contactModel);
	}
}

export const contactService = new ContactService();
